module.exports = __webpack_public_path__ + "static/media/0108_Small.dd5f95b4.jpg";